<template lang="pug">
    v-dialog(v-model='dialog', persistent, max-width='700px')
        template(v-slot:activator='{ on }')
            v-btn.ml-2(icon v-on='on' @click="importBranding(branding)") 
             v-icon(small) mdi-pencil
        v-card
            v-card-title Update Branding
            v-divider
            v-card-text.mt-4
              v-row.align-center
                v-col.text-center(cols="12" md="6")
                  | Upload the logo
                  v-btn(link small text hide-details target="_blank" v-bind:href="''+bucket+'?region=eu-central-1&prefix=protected/'+tenantId+'/&showversions=false'") here
                v-col(cols="12" md="6")
                  v-text-field.mt-2(v-model="logo" rounded filled label="Set logo filename")
            
                v-col(cols="12" md="6")
                  h2.mb-2 Primary Color
                  v-color-picker.no-alpha(v-model="primaryColor" mode="hexa" swatches-max-height="200")
                v-col(cols="12" md="6")
                  h2.mb-2 Accent Color
                  v-color-picker(v-model="accentColor" mode="hexa" swatches-max-height="200")
            v-divider
            v-card-actions
                v-spacer
                v-btn(text, @click='closeDialog') {{$t("general.cancel")}}
                v-btn(color='accent', text, @click="updateBrandingFunction")  {{$t("general.save")}}
</template>
<script>
import awsmobile from "@/aws-exports.js";
export default {
  props: ["branding", "tenantId"],
  data() {
    return {
      dialog: false,
      primaryColor: "",
      accentColor: "",
      logo: "",
      bucket:
        "https://s3.console.aws.amazon.com/s3/buckets/" +
        awsmobile.aws_user_files_s3_bucket,
    };
  },
  computed: {},
  watch: {
    primaryColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.primaryColor = value.substr(0, 7);
      }
    },
    accentColor(value) {
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.accentColor = value.substr(0, 7);
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },

    importBranding(branding) {
      this.primaryColor = branding.primaryColor;
      this.accentColor = branding.accentColor;
      this.logo = branding.logo;
    },
    async updateBrandingFunction() {
      const response = await this.$store.dispatch(
        "superAdmin/UPDATE_TENANT_BRANDING",
        {
          brandingId: this.branding.id,
          primaryColor: this.primaryColor,
          accentColor: this.accentColor,
          logo: this.logo,
        }
      );
      if (response) this.closeDialog();
    },
  },
};
</script>
<style lang="scss" scoped>
.no-alpha {
  .v-color-picker__controls {
    .v-color-picker__preview {
      .v-color-picker__sliders {
        .v-color-picker__alpha {
          display: none;
        }
      }
    }
    .v-color-picker__edit {
      .v-color-picker__input:last-child {
        display: none;
      }
    }
  }
}
</style>
